// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"494":"3756041f075e4f26","763":"9ced2f1611e0217c"}[chunkId] + ".js";
};